(function () {
	"use strict";

	if (window.__jelriEmergencyNativeCart20260805) {
		return;
	}

	window.__jelriEmergencyNativeCart20260805 = true;

	function route(path) {
		var root = "/";

		if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
			root = window.Shopify.routes.root;
		}

		return root.replace(/\/?$/, "/") + path.replace(/^\/+/, "");
	}

	function selectedOptionValues(form) {
		var optionsContainer = form.querySelector(".js-product-options");
		var values = [];

		if (!optionsContainer) {
			return values;
		}

		for (var position = 1; position <= 3; position += 1) {
			var name = "option" + position;
			var select = optionsContainer.querySelector('select[name="' + name + '"]');
			var checked = optionsContainer.querySelector('input[name="' + name + '"]:checked');
			var anyControl = optionsContainer.querySelector('[name="' + name + '"]');

			if (select) {
				values.push(select.value);
			} else if (checked) {
				values.push(checked.value);
			} else if (anyControl) {
				return [];
			} else {
				break;
			}
		}

		return values;
	}

	function syncVariantId(form) {
		var variantInput = form.querySelector('[name="id"]');
		var productJson = form.querySelector("[data-js-product-json]");
		var selectedValues = selectedOptionValues(form);
		var product;
		var variants;

		if (!variantInput || !productJson || !selectedValues.length) {
			return;
		}

		try {
			product = JSON.parse(productJson.textContent);
		} catch (error) {
			return;
		}

		variants = product && Array.isArray(product.variants) ? product.variants : [];

		for (var index = 0; index < variants.length; index += 1) {
			var variant = variants[index];
			var variantOptions = Array.isArray(variant.options) ? variant.options : [];
			var matches = selectedValues.every(function (value, optionIndex) {
				return String(variantOptions[optionIndex]) === String(value);
			});

			if (matches && variant.id) {
				variantInput.value = variant.id;
				return;
			}
		}
	}

	function ensureReturnToCart(form) {
		var returnTo = form.querySelector('input[name="return_to"]');

		if (!returnTo) {
			returnTo = document.createElement("input");
			returnTo.type = "hidden";
			returnTo.name = "return_to";
			form.appendChild(returnTo);
		}

		returnTo.value = route("cart");
	}

	function resetSubmittingState(form) {
		delete form.dataset.jelriNativeSubmitting;
		form.removeAttribute("aria-busy");

		Array.prototype.forEach.call(form.querySelectorAll('[type="submit"]'), function (button) {
			button.removeAttribute("aria-disabled");
			button.classList.remove("loading");
		});
	}

	window.addEventListener("pageshow", function () {
		Array.prototype.forEach.call(document.querySelectorAll("[data-jelri-native-submitting]"), resetSubmittingState);
	});

	window.addEventListener(
		"submit",
		function (event) {
			var form = event.target;
			var submitter = event.submitter;

			if (!form || form.nodeName !== "FORM") {
				return;
			}

			if (!form.matches("[data-js-product-form], .js-quick-view-form")) {
				return;
			}

			if (submitter && submitter.closest && submitter.closest(".shopify-payment-button")) {
				return;
			}

			if (!form.querySelector('[name="id"]')) {
				return;
			}

			if (form.querySelector(".js-recipient-form-checkbox, .js-custom-field-block")) {
				return;
			}

			if (form.dataset.jelriNativeSubmitting === "true") {
				event.preventDefault();
				event.stopImmediatePropagation();
				return;
			}

			syncVariantId(form);
			ensureReturnToCart(form);

			form.action = route("cart/add");
			form.method = "post";
			form.enctype = "multipart/form-data";
			form.dataset.jelriNativeSubmitting = "true";
			form.setAttribute("aria-busy", "true");

			Array.prototype.forEach.call(form.querySelectorAll('[type="submit"]'), function (button) {
				button.setAttribute("aria-disabled", "true");
				button.classList.add("loading");
			});

			// Keep the browser's native form submission and stop the theme's AJAX cart listener.
			event.stopImmediatePropagation();
		},
		true
	);
})();
